/**
 * Public measurement IDs for the Zetech University website.
 *
 * These are *publishable* identifiers (they are visible in the page source of
 * every site that uses them), so they are safe to keep in the repository.
 * Environment variables still win when they are set, which lets staging or
 * forks point at a different property without touching code.
 *
 * Never put a private/secret key here (e.g. a PostHog "phs_"/"phx_" key or a
 * Google Ads API secret) — those belong in server-side secrets only.
 */
export const ANALYTICS_IDS = {
  REACT_APP_GTM_ID: "GTM-583XWWSF",
  // GA4 property shown in the Analytics account picker. The web stream's
  // G-… measurement ID and its Google tag must be configured in this GTM container.
  REACT_APP_GA_PROPERTY_ID: "286769651",
  REACT_APP_FACEBOOK_PIXEL_ID: "",
  // PostHog project token — must start with "phc_" (Project settings -> Project API key).
  REACT_APP_POSTHOG_KEY: "phc_zF3cnePbttAdBWaAMrbeReRirbpnzmDWLbJc54Avn4Qn",
  REACT_APP_POSTHOG_HOST: "https://us.i.posthog.com",
  REACT_APP_AHREFS_KEY: "UiVyBSXIvwYtHZKAhj571A",
  REACT_APP_CLARITY_PROJECT_ID: "ykszl1x6u2",
};

export default ANALYTICS_IDS;
